<template>
    <v-panel
        v-model="isShow"
        :class="panelClass"
        :mask-closable="false"
        :width="700"
    >
        <div
            slot="header"
            class="priv-list-panel-header"
        >
            <div class="priv-list-panel-header-back">
                <a
                    @click="isShow = false"
                    href="javascript:;"
                >
                    <v-icon name="back" /><span class="link-text">{{ backTxt }}</span>
                </a>
            </div>
            <div class="priv-list-panel-header-tit">
                <h3>{{ roleData.roleName }}</h3>
                <p
                    v-for="(packName, packId) in roleData.packages"
                    :key="packId"
                >
                    {{ packName }}
                </p>
            </div>
            <link-refresh
                :link-url="'/mng/role#/edit/' + roleData.roleId"
                :link-txt="roleData.isAdmin ? '' : '编辑角色'"
                @refresh="privRefresh"
            />
        </div>
        <div class="priv-list-panel-content">
            <!-- 默认不拉权限列表 -->
            <priv-detail-list
                ref="privList"
                v-if="isShow"
                :key="roleData.roleId"
                :role-id="roleData.roleId"
            />
        </div>
    </v-panel>
</template>
<script>
import PrivDetailList from '@/components/priv-detail-list';
import LinkRefresh from 'src/components/link-refresh';

export default {
    components: {
        PrivDetailList,
        LinkRefresh,
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },

        backTxt: {
            type: String,
            default: '返回角色',
        },

        roleData: {
            type: Object,
            default() {
                return {};
            },
        },
    },

    data() {
        return {};
    },
    computed: {
        isShow: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },

        panelClass() {
            const packages = (this.roleData && this.roleData.packages) || {};
            return `priv-list-panel priv-list-panel-package-${Object.keys(packages).length}`;
        },
    },
    created() {
        console.log('4t3tr', this.roleData, '9', this.value);
    },

    methods: {
        backClick() {
            console.log('backClick');
        },

        privRefresh() {
            this.$refs.privList.refresh();
        },
    },
};
</script>

<style lang="less">
@import './index.less';
</style>
